import { Directive, OnDestroy, OnInit } from '@angular/core';
import { Subscription, filter, tap } from 'rxjs';

import { AlertsService } from './alerts.service';
import { IAlert } from './alerts.interfaces';

@Directive()
export abstract class BaseAlertsOutletComponent implements OnInit, OnDestroy {
  protected subscription = new Subscription();

  constructor(protected readonly service: AlertsService) { }

  ngOnInit(): void {
    const queueSub = this.service.showAlert$
      .pipe(
        filter((show) => {
          if (show === null) {
            this.dismissAllAlerts();
            return false;
          }

          return true;
        }),
        tap((alert) => {
          if (!alert) {
            return;
          }

          this.showAlert(alert);
        }),
      )
      .subscribe();

    this.subscription.add(queueSub);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  abstract showAlert(alert: IAlert): void;
  abstract dismissAllAlerts(): void;
}
